import script from "./custom-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./custom-detail.vue?vue&type=script&lang=ts&setup=true"

import "./custom-detail.vue?vue&type=style&index=0&id=eb06606e&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb06606e"]])

export default __exports__